//fixedLineBox
// はじめてのアクセス時にactiveクラスを追加
// if (sessionStorage.getItem("visited") === null) {
//   document.querySelector(".fixedLineBox").classList.add("active");
//   sessionStorage.setItem("visited", "true");
// } else {
//   // 2ページ目以降の遷移時にactiveクラスを除去し、notActiveクラスを追加
//   document.querySelector(".fixedLineBox").classList.remove("active");
//   document.querySelector(".fixedLineBox").classList.add("notActive");
// }

//smooth sscroll
$(function () {
  $('a[href^="#"]').click(function () {
    var adjust = -100;
    var speed = 1200;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top + adjust;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});
//mainvisual slider

//hamburger menu
$(function () {
  function toggleNav() {
    const body = document.body;
    const hamburger = document.getElementById("js-hamburger");
    const overlay = document.getElementById("js-overlay");
    hamburger.addEventListener("click", function () {
      body.classList.toggle("nav-open");
    });
    overlay.addEventListener("click", function () {
      body.classList.remove("nav-open");
    });
  }
  toggleNav();
});

document.addEventListener("DOMContentLoaded", function () {
  var videos = document.querySelectorAll("div.product__description video");

  videos.forEach(function (video) {
    video.setAttribute("autoplay", "");
    video.setAttribute("loop", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("muted", "");
    video.removeAttribute("controls");
    video.muted = true;
    video.play();
  });
});

// hamburger open fix background
// $(function () {
//   let state = false;
//   let scrollpos;
//   $('#js-hamburger,#js-overlay').on('click', function () {
//     if (state == false) {
//       scrollpos = $(window).scrollTop();
//       $('body').addClass('fixed').css({ top: -scrollpos });
//       state = true;
//     } else {
//       $('body').removeClass('fixed').css({ top: 0 });
//       window.scrollTo(0, scrollpos);
//       state = false;
//     }
//   });
// });
